import React, { useState, useEffect } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState('enter'); // enter -> hold -> exit

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('hold'), 600);
    const t2 = setTimeout(() => setPhase('exit'), 2000);
    const t3 = setTimeout(() => onComplete(), 2600);
    const prevOverflow = document.body.style.overflow;
    const prevBg = document.documentElement.style.background;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.background = 'var(--club-green)';
    return () => {
      clearTimeout(t1); clearTimeout(t2); clearTimeout(t3);
      document.body.style.overflow = prevOverflow;
      document.documentElement.style.background = prevBg;
    };
  }, [onComplete]);

  return (
    <div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center transition-opacity duration-500"
      style={{
        background: 'var(--club-green)',
        opacity: phase === 'exit' ? 0 : 1,
        pointerEvents: phase === 'exit' ? 'none' : 'auto',
      }}
      data-testid="splash-screen"
    >
      {/* Subtle radial gradient overlay */}
      <div className="absolute inset-0" style={{
        background: 'radial-gradient(circle at 50% 40%, rgba(255,255,255,0.06) 0%, transparent 60%)',
      }} />

      {/* Logo */}
      <div
        className="relative transition-all duration-700 ease-out"
        style={{
          opacity: phase === 'enter' ? 0 : 1,
          transform: phase === 'enter' ? 'scale(0.85) translateY(12px)' : 'scale(1) translateY(0)',
        }}
      >
        <img
          src="/logo-the-club.png"
          alt="The Club"
          className="h-28 w-auto drop-shadow-2xl"
          style={{ filter: 'brightness(1.15)' }}
        />
      </div>

      {/* Tagline */}
      <p
        className="mt-5 text-sm font-medium tracking-[0.2em] uppercase transition-all duration-700 delay-200"
        style={{
          color: 'rgba(255,255,255,0.6)',
          opacity: phase === 'enter' ? 0 : 1,
          transform: phase === 'enter' ? 'translateY(8px)' : 'translateY(0)',
        }}
      >
        Find Your Foursome
      </p>

      {/* Loading bar */}
      <div className="absolute bottom-16 w-20 h-0.5 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.15)' }}>
        <div
          className="h-full rounded-full transition-all ease-linear"
          style={{
            background: 'var(--gold)',
            width: phase === 'enter' ? '0%' : phase === 'hold' ? '70%' : '100%',
            transitionDuration: phase === 'hold' ? '1400ms' : '500ms',
          }}
        />
      </div>
    </div>
  );
};

export default SplashScreen;
